import { render, staticRenderFns } from "./IncomeMarketplaceDetailsPopup.vue?vue&type=template&id=48cee414"
import script from "./IncomeMarketplaceDetailsPopup.vue?vue&type=script&lang=js"
export * from "./IncomeMarketplaceDetailsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports